import { useTheme } from '../../contexts/ThemeContext';
import classNames from 'classnames';

export default function SectionHeader({
  label,
  title,
  titleHighlight,
  highlightColor = 'purple',
  subtitle,
  align = 'center'
}) {
  const { darkMode } = useTheme();

  const alignClasses = {
    left: 'text-left',
    center: 'text-center',
    right: 'text-right'
  };

  const highlightColors = {
    purple: 'text-main',
    orange: 'text-main-orange'
  };

  return (
    <div className={classNames(alignClasses[align], 'mb-12')}>
      {label && (
        <span className="text-main uppercase tracking-widest text-sm font-semibold mb-4 block">
          {label}
        </span>
      )}

      <h2 className={classNames(
        'titleFont text-4xl md:text-5xl lg:text-6xl font-bold',
        darkMode ? 'text-white' : 'text-gray-900'
      )}>
        {title}
        {titleHighlight && (
          <span className={highlightColors[highlightColor]}> {titleHighlight}</span>
        )}
      </h2>

      {subtitle && (
        <p className={classNames(
          'mt-4 text-lg md:text-xl max-w-3xl',
          align === 'center' && 'mx-auto',
          darkMode ? 'text-gray-400' : 'text-gray-600'
        )}>
          {subtitle}
        </p>
      )}
    </div>
  );
}
